export const MenuList = [
    {
        title: 'Ventas',
        classsChange: 'mm-collapse',
        iconStyle: <i className="material-icons">receipt_long</i>,
        content: [
            { title: 'Clientes', to: 'Clientes', permiso: "ventas.clientes" },
            { title: 'Facturas', to: 'Facturas', permiso: "ventas.facturas" },
            { title: 'Detalles', to: 'Detalles', permiso: "ventas.detalles" },
            { title: 'Reportes', to: 'Reporte', permiso: "ventas.reportes" },
        ],
    },
    {
        title: 'Facturas Contado',
        classsChange: 'mm-collapse',
        iconStyle: <i className="material-icons">request_quote</i>,
        content: [
            { title: 'Depositado', to: 'depositado', permiso: "ventas.facturascontado" },
            { title: 'No Depositado', to: 'nodepositado', permiso: "ventas.facturascontado" },
        ],
    },
    {
        title: 'Facturas Credito',
        classsChange: 'mm-collapse',
        iconStyle: <i className="material-icons">credit_score</i>,
        content: [
            { title: 'Pagados', to: 'cobranza', permiso: "ventas.facturascredito" },
            { title: 'No Pagados', to: 'vencimientos', permiso: "ventas.facturascredito" },
        ],
    },
    {
        title: 'Compras',
        classsChange: 'mm-collapse',
        iconStyle: <i className="merial-icons">receipt_long</i>,
        content: [
            { title: 'Proveedores', to: 'proveedores', permiso: "compras.proveedores" },
            { title: 'Compras', to: 'compras', permiso: "compras.compras" },
            { title: 'Lista de compras', to: 'listadecompras', permiso: "compras.listacompra" },
            { title: 'Reporte Compras', to: 'reportecompras', permiso: "compras.reporte" },
            {
                title: "Cheques",
                to: "/cheques",
                permiso: "compras.proveedores", // MISMO PERMISO
            },
        ],
    },
    {
        title: 'Opciones',
        classsChange: 'mm-collapse',
        iconStyle: <i className="merial-icons">settings</i>,
        content: [
            { title: 'Timbrado', to: 'Opcionesdetimbrado', permiso: "opciones.timbrado" },
            { title: 'Sucursal', to: 'Opcionesdesucursal', permiso: "opciones.sucursal" },
            { title: 'Puntos de Venta', to: 'Opcionesodv', permiso: "opciones.puntosdeventa" },
            { title: 'Formas de pago', to: 'Opcionesformadepago', permiso: "opciones.formadepago" },
            { title: 'Servicio/Producto', to: 'Opcionesdecosto', permiso: "opciones.servicioproducto" },
            { title: 'Seguros', to: 'Opcionesseguros', permiso: "opciones.seguros" },
             { title: 'Chequera', to: 'Opcionesdecheques', permiso: "opciones.timbrado" },
        ],
    },
    {
        title: 'Presupuestos',
        classsChange: 'mm-collapse',
        iconStyle: <i className="merial-icons">receipt</i>,
        content: [
            { title: 'Presupuestos', to: 'presupuestos', permiso: "ventas.clientes" },
            { title: 'Nuevo', to: 'nuevopresupuesto', permiso: "ventas.clientes" },
        ],
    },
    {
        title: 'Admin',
        iconStyle: <i className="material-icons">manage_accounts</i>,
        to: 'admin',
        permiso: "Admin"
    },
]